import { formatRelative } from '@koob/dates';
import { icons } from '@koob/ui';
import Markdown from 'markdown-to-jsx';
import { useTranslation } from 'react-i18next';
import NotificationPopoverListItemActions from './NotificationPopoverListItemActions';
import NotificationPopoverListItemIcon from './NotificationPopoverListItemIcon';

export default function NotificationPopoverListItem({
  notification,
  markAsRead,
  navigate,
  scope,
}) {
  const { t } = useTranslation('notifications');
  const unread = !notification.readAt;

  return (
    <div className="group relative flex gap-3 px-4 py-3 transition hover:bg-gray-50">
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-gray-100">
        <NotificationPopoverListItemIcon notification={notification} />
      </div>

      <div className="min-w-0 flex-1">
        <div className="flex items-start gap-2">
          <div className="min-w-0 flex-1 text-sm font-semibold text-k-h">
            {notification.title}
          </div>
          <div className="flex shrink-0 items-center gap-2">
            {unread && (
              <button
                type="button"
                aria-label={t('markAsRead')}
                title={t('markAsRead')}
                onClick={() => markAsRead(notification.id)}
                className="inline-flex h-6 w-6 cursor-pointer items-center justify-center rounded-md border-none bg-transparent text-k-p opacity-0 transition hover:bg-gray-100 hover:text-k-h focus-visible:opacity-100 group-hover:opacity-100"
              >
                <i className={`${icons.check} text-xs`} />
              </button>
            )}
            <span
              aria-hidden="true"
              className={`h-2 w-2 rounded-full ${
                unread ? 'bg-orange-500' : 'bg-transparent'
              }`}
            />
          </div>
        </div>

        <div className="mt-0.5 text-xs text-k-p">
          <Markdown>{notification.description}</Markdown>
        </div>

        <div className="mt-2 flex items-center justify-between gap-2">
          <div>
            {notification?.actions?.length > 0 && (
              <NotificationPopoverListItemActions
                notification={notification}
                navigate={navigate}
                scope={scope}
              />
            )}
          </div>
          <div className="shrink-0 text-xs text-gray-400">
            {formatRelative(notification.createdAt)}
          </div>
        </div>
      </div>
    </div>
  );
}
